import React from 'react';
import { Spin } from 'antd';
import { LoadingWrapper } from './styles';

interface LoadingProps {
	size?: 'small' | 'default' | 'large';
}

export function Loading({ size = 'large' }: Readonly<LoadingProps>): JSX.Element {
	return (
		<LoadingWrapper>
			<Spin size={size} />
		</LoadingWrapper>
	);
}
